export default __webpack_public_path__ + "d1b47995391f1ffb5ae7b786293b5bf5.json";